import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type ToastType = "success" | "error";

export interface ToastItem {
	id: string;
	message: string;
	type: ToastType;
	duration?: number; // ms, default 4000
}

interface ToastState {
	toasts: ToastItem[];
}

const initialState: ToastState = {
	toasts: [],
};

const toastSlice = createSlice({
	name: "toast",
	initialState,
	reducers: {
		addToast: (state, action: PayloadAction<Omit<ToastItem, "id">>) => {
			const id = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
			state.toasts.push({ id, duration: 4000, ...action.payload });
		},
		removeToast: (state, action: PayloadAction<string>) => {
			state.toasts = state.toasts.filter((t) => t.id !== action.payload);
		},
	},
});

export const { addToast, removeToast } = toastSlice.actions;
export default toastSlice.reducer;
